import { CommonModule, NgOptimizedImage } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { LottieComponent } from 'ngx-lottie';
import { NavSideComponent } from './components/admin-layouts/components/nav-side/nav-side.component';
import { NavTopComponent } from './components/admin-layouts/components/nav-top/nav-top.component';
import { FilteredProjectsComponent } from './components/filtered-projects/filtered-projects.component';
import { FooterComponent } from './components/layouts/footer/footer.component';
import { NavHeaderComponent } from './components/layouts/nav-header/nav-header.component';
import { SiteSearchComponent } from './components/layouts/site-search/site-search.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { GalleryViewerComponent } from './components/gallery-viewer/gallery-viewer.component';
import { LightboxComponent } from './components/gallery-viewer/lightbox/lightbox.component';
import { WarningMessageComponent } from './components/warning-message/warning-message.component';
import { MaterialModule } from './material/material.module';
import { TranslatePipe } from './pipes/translate.pipe';
import { TruncatePipe } from './pipes/truncate.pipe';
import { YoutubeIdPipe } from './pipes/youtube-id.pipe';
import { LazyVideoSourceDirective } from './directives/lazy-video-source.directive';
import { MediaUrlPipe } from './pipes/media-url.pipe';

@NgModule({
  declarations: [
    TranslatePipe,
    NavHeaderComponent,
    SiteSearchComponent,
    FooterComponent,
    WarningMessageComponent,
    TruncatePipe,
    FilteredProjectsComponent,
    NavSideComponent,
    NavTopComponent,
    SpinnerComponent,
    YoutubeIdPipe,
  ],
  imports: [
    CommonModule,
    NgOptimizedImage,
    GalleryViewerComponent,
    LightboxComponent,
    LazyVideoSourceDirective,
    MediaUrlPipe,
    RouterLink,
    RouterLinkActive,
    ReactiveFormsModule,
    FormsModule,
    LottieComponent,
    MaterialModule
  ],
  exports: [
    MaterialModule,
    TranslatePipe,
    NavHeaderComponent,
    FooterComponent,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    WarningMessageComponent,
    TruncatePipe,
    FilteredProjectsComponent,
    NavSideComponent,
    NavTopComponent,
    LottieComponent,
    SpinnerComponent,
    YoutubeIdPipe,
    GalleryViewerComponent,
    LightboxComponent,
    LazyVideoSourceDirective,
    MediaUrlPipe,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule { }
